// extracted by mini-css-extract-plugin
module.exports = {"warning-text":"warning-text___2ajZq","agent-badge":"agent-badge___7XW9t","warning-group-info":"warning-group-info___1gz9f"};